
    import Vue from 'vue';

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    
// 工单选择时限

// 时限反查
export const timeListRe = {
  300: $t('e399d2'),
  600: $t('2b44ce'),
  1800: $t('7b0809'),
  3600: $t('bd4dad'),
  7200: $t('c44d6a'),
  28800: $t('df81e7'),
  43200: $t('bc5b47'),
  43500: $t('9593fc'),
}

// 工单状态
export const workflowStatus = {
  10: $t('786593'),
  20: $t('60d4b9'),
  30: $t('0ae3ae'),
  40: $t('a0acfa'),
}

// 工单操作类型
export const workflowHandleType = {
  10: $t('24c8f4'),
  20: $t('980d2d'),
  30: $t('b68e06'),
  40: $t('25e031'),
  50: $t('15b362'),
}

// 渠道来源
export const channel = {
  wechat_work: 5,
  sms: 1,
  dingding: 6,
  fly_book: 7,
}

// 预警状态
export const readStatus = {
  0: $t('e373f0'),
  1: $t('2f51be'),
  2: $t('2f0965'),
}

// 预警记录 自定义状态
export const handleStatus = {
  0: $t('e2d57c'),
  1: $t('0ae3ae'),
  2: $t('2f0965'),
  '-1': $t('f4b18d'),
}
